export const hintMixin = {
  data() {
    return {
      status: false,
      statusTimeout: null
    }
  },
  methods: {
    showHint() {
      this.status = true
      this.statusTimeout = setTimeout(() => {
        this.status = false
        clearTimeout(this.statusTimeout)
      }, 4000)
    },
    hideHint() {
      this.status = false
      clearTimeout(this.statusTimeout)
      this.statusTimeout = null
    }
  }
}
